import { render, staticRenderFns } from "./zmodal.vue?vue&type=template&id=2f518c38&scoped=true&"
import script from "./zmodal.vue?vue&type=script&lang=js&"
export * from "./zmodal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f518c38",
  null
  
)

export default component.exports